import { render, staticRenderFns } from "./r-product-track-panel.vue?vue&type=template&id=099bc21e"
import script from "./r-product-track-panel.vue?vue&type=script&lang=js"
export * from "./r-product-track-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('099bc21e')) {
      api.createRecord('099bc21e', component.options)
    } else {
      api.reload('099bc21e', component.options)
    }
    module.hot.accept("./r-product-track-panel.vue?vue&type=template&id=099bc21e", function () {
      api.rerender('099bc21e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/product/r-product-track-panel.vue"
export default component.exports